import React from "react";
import QRCode from "react-qr-code";
import Costanti from "../constantiX";

const QrcodeProduct = ({ id }) => {
  return (
    <a target="_blank" rel="noreferrer" href={`${Costanti.UrlCallApi}file/qrcode/${id}?base=${Costanti.BaseHttpFe}`}>
      <QRCode size={100} value={`${Costanti.BaseHttpFe}#/scheda/${id}`} />
    </a>
  );
};
export default QrcodeProduct;
